import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL

class CorsApi {
  addCors(data, config) {
    return axios.post(`${baseUrl}/corsConfig`, data, config)
  }

  updateCors(id, data, config) {
    return axios.put(`${baseUrl}/corsConfig/${id}`, data, config)
  }

  deleteCors(id) {
    return axios.delete(`${baseUrl}/corsConfig/${id}`)
  }

  getCors() {
    return axios.get(`${baseUrl}/corsConfig`)
  }
}

export default new CorsApi()
